import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import {
    GridColDef,
    GridPaginationModel,
    GridRowParams,
} from '@mui/x-data-grid';

import { DataGrid, DataGridCard } from '@barboxx/admin-components';
import { usePaging } from '@barboxx/admin-utils';
import Api from '@barboxx/api';

const COLUMNS: GridColDef[] = [
    { field: 'name', headerName: 'Name', width: 200, flex: 1 },
    {
        field: 'streetAddress',
        headerName: 'Address',
        width: 300,
        flex: 1,
        sortable: false,
    },
    { field: 'city', headerName: 'City', width: 200 },
    { field: 'state', headerName: 'State', width: 100 },
    { field: 'zip', headerName: 'Zip Code', width: 100 },
    {
        field: 'enabled',
        headerName: 'Enabled',
        type: 'boolean',
        width: 100,
        sortable: false,
    },
    {
        field: 'category',
        headerName: 'Type',
        width: 100,
    },
];

interface Props {
    searchString?: string;
}

export default function PlacesList({ searchString }: Props) {
    const navigate = useNavigate();

    const { page, size, sort, updatePageModel, updateSort } = usePaging();
    const { data, isLoading, error } = useQuery({
        queryKey: ['places', page, size, sort, searchString],
        queryFn: () =>
            Api.Places.getPlaces({
                page,
                size,
                sort,
                searchString,
            }),
    });

    const handleChangePageModel = (pageModel: GridPaginationModel) => {
        updatePageModel(pageModel);
    };

    const handleRowClick = (param: GridRowParams) => {
        navigate(`${param.id}`);
    };

    return (
        <DataGridCard>
            <DataGrid
                columns={COLUMNS}
                disableColumnMenu
                disableRowSelectionOnClick
                error={error}
                loading={isLoading}
                onRowClick={handleRowClick}
                paginationModel={{
                    page,
                    pageSize: size,
                }}
                onPaginationModelChange={handleChangePageModel}
                onSortModelChange={updateSort}
                rows={data?.data?.results ?? []}
                rowCount={data?.data?.total ?? 0}
            />
        </DataGridCard>
    );
}
